module.exports = "\n<menu-layout class=\"marketers-page\" data-title=\"{{'MARKETERS' | translate}}\">\n\n\n\t<div class=\"marketers-page__actions\">\n\t\t<button class=\"btn btn-default\" ng-click=\"marketers.create()\"><span class=\"icon icon-plus\"></span> {{'ADD_MARKETER' | translate}}</button>\n\t</div>\n\n\t<custom-table\n\t\theaders=\"marketers.headers\"\n\t\tdata=\"marketers.marketers\"\n\t>\n\t\t<div class=\"no-result\">\n\t\t\t<h1>{{'NO_MARKETER' | translate}}</h1>\n\t\t\t<h4>{{'ADD_MARKETER_TUTO' | translate}}</h4>\n\t\t</div>\n\t</custom-table>\n\n\n</menu-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/page/marketers/marketers.html
// module id = 517
// module chunks = 0